import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { initAnalytics } from './utils/analytics';
import { hasConsented } from './utils/consent';

/* Google Analytics only loads for a visitor who has actually said yes.
   It used to load here for everyone, before anything was asked. A
   first-time visitor sees the banner instead; accepting starts the tag
   straight away (see components/CookieBanner.js). */
if (hasConsented()) initAnalytics();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
